import {inject, Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PaypalService {
  sdkLoaded = false;
  private scriptId = 'paypal-sdk-script';

  loadPaypalSdk(): Promise<void> {
    if (this.sdkLoaded) {
      return Promise.resolve(); // already loaded
    }
    return new Promise((resolve, reject) => {
      if (document.getElementById('paypal-sdk')) {
        this.sdkLoaded = true;
        return resolve();
      }

      const script = document.createElement('script');
      script.id = this.scriptId;

      // Use environment values to build the URL:
      script.src = `https://www.paypal.com/sdk/js?client-id=${environment.paypalClientId}&currency=EUR&vault=true`;

      script.onload = () => resolve();
      script.onerror = (err) => reject(err);
      document.body.appendChild(script);
    });
  }


}
